import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { map, startWith, takeUntil, tap } from "rxjs/operators";

@Component({
  selector: "app-input-autocomplete",
  templateUrl: "./input-autocomplete.component.html",
  styleUrls: ["./input-autocomplete.component.scss"],
})
export class InputAutocompleteComponent implements OnInit, AfterViewInit {
  public filteredOptions$: Observable<InputAutocompleteOption[]>;
  public inputFormControl = new FormControl();
  public destroy$ = new Subject();
  @Input() emitAllChanges: boolean; //if true emits all input value changes as well as when an autocomplete option is selected whereas if field is false, emits either one option if selected or only one left after filtering or emits an empty string if more than one option is available
  @Input() placeholder = "";
  @Input() tooltip;
  @Input() isRequired;
  @Input() control: FormControl;
  @Input() label;
  @Input() options: InputAutocompleteOption[] = [];
  @ViewChild("autoInput", { read: ElementRef }) inputElRef: ElementRef;
  ngOnInit(): void {
    this.filteredOptions$ = this.inputFormControl.valueChanges.pipe(
      startWith(""),
      map((filterString) => this.filter(filterString))
    );
    if (this.emitAllChanges) {
      this.inputFormControl.valueChanges
        .pipe(
          takeUntil(this.destroy$),

          tap((input) => {
            this.control.setValue(input);
          })
        )
        .subscribe();
    }
  }
  ngAfterViewInit() {
    if (this?.control?.value) {
      const initValue = this.options.find(
        (option) => option.value === this.control.value
      )?.text;
      this.inputElRef.nativeElement.value = initValue || "";
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  filter(value: string): InputAutocompleteOption[] {
    const filterValue = value.toLowerCase();
    if (!filterValue) return this.options;
    const filteredOptions = this.options.filter((option: any) =>
      option.text.toLowerCase().includes(filterValue.toLowerCase())
    );
    if (!this.emitAllChanges) {
      // already setting value elsewhere
      if (filteredOptions.length === 1) {
        this.inputElRef.nativeElement.value = filteredOptions[0].text;
        this.control.setValue(filteredOptions[0].value);
      } else {
        this.control.setValue("");
      }
    }

    return filteredOptions;
  }

  clearField() {
    this.inputFormControl.setValue("");
    this.inputElRef.nativeElement.focus();
  }

  updateWithSelection($event) {
    const selectedOption = this.options.find(
      (option) => option.value === $event
    );
    if (selectedOption) {
      this.inputElRef.nativeElement.value = selectedOption.text;
      this.control.setValue(selectedOption.value);
    }
  }

  handleInitSearch() {}
}

export interface InputAutocompleteOption {
  text: string;
  value: any;
}
